export default {
  direct: 'detail_contact_direct',
  top: 'detail_contact_top',
  blur: 'detail_contact_blur',
  blur_oneclick: 'detail_contact_blur_oneclick',
  top_oneclick: 'detail_contact_top_oneclick',
  middle: 'detail_contact_middle',
  bottom: 'detail_contact_bottom',
  float: 'detail_contact_float'
}